/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AsiUserDto } from '../../models/asi-user-dto';

export interface GetSecurityExpertFilter$Params {
  user: AsiUserDto;
}

export function getSecurityExpertFilter(http: HttpClient, rootUrl: string, params: GetSecurityExpertFilter$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<number>>> {
  const rb = new RequestBuilder(rootUrl, getSecurityExpertFilter.PATH, 'get');
  if (params) {
    rb.query('user', params.user, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<number>>;
    })
  );
}

getSecurityExpertFilter.PATH = '/auth/security-expert-filter';
